module.exports = __webpack_public_path__ + "media/images/proof_links/colored/ivi-dbfea5a27f201de5735a3ce7171a8c4a.svg";